module.exports = __webpack_public_path__ + "static/img/RB 102.c9de3fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-2/RB 102.png
// module id = jYdD
// module chunks = 12